<template>
  <v-container fluid fill-height  justify-center
      align-center grid-list-xl>
      <spinner v-if="dataLoading === true" line-fg-color="#28AFAF" size="large"></spinner>
      <v-flex v-else xs12 sm12 md10 lg5>
        <v-card class="elevation-1">
          <v-toolbar color="primary">
            <v-btn icon class="white--text" @click="goBack">
              <v-icon>arrow_back</v-icon>
            </v-btn>
            <v-toolbar-title class="white--text">Agency Details</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn icon class="white--text" @click="editAgency(agencyData)" >
              <v-icon>edit</v-icon>
            </v-btn>
            <v-dialog v-model="dialog" persistent max-width="290">
              <v-btn 
              slot="activator"
              flat 
              icon 
              class="white--text">
              <v-icon>delete</v-icon>
            </v-btn>
              <v-card>
                <v-card-title class="headline">Confirm your action</v-card-title>
                <v-card-text>Are you sure you want to delete this agency?<br>This action can not be reverted</v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="primary"  @click.native="closeDialog()">Disagree</v-btn>
                  <v-btn color="red" dark  @click.native="closeDialog(); deleteItem(agencyData.id)">Delete</v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </v-toolbar>
          <v-card flat>
            <v-card-media>
              <v-container fluid fill-height>
                <v-layout 
                  justify-center
                  align-center>
                  <v-avatar
                      size="150px"
                      :tile="false"
                    >
                    <img :src="agencyData.logo_url || defaultLogo" alt="avatar">
                  </v-avatar>
                </v-layout>
              </v-container>
            </v-card-media>
            <v-card-text>
              <v-list two-line>
                <v-card-title class="black--text">
                    <div class="display-1">{{ agencyData.company }}  </div>
                  </v-card-title>
                  <v-list-tile>
                    <v-list-tile-action>
                      <v-icon color="primary">fingerprint</v-icon>
                    </v-list-tile-action>
                    <v-list-tile-content>
                      <v-list-tile-title>{{ agencyData.id }}</v-list-tile-title>
                      <v-list-tile-sub-title>ID</v-list-tile-sub-title>
                    </v-list-tile-content>
                  </v-list-tile>
                  <v-divider inset></v-divider>
                <v-list-tile>
                  <v-list-tile-action>
                    <v-icon color="primary">work</v-icon>
                  </v-list-tile-action>
                  <v-list-tile-content>
                    <v-list-tile-title>{{ agencyType }}</v-list-tile-title>
                    <v-list-tile-sub-title>Agency Type</v-list-tile-sub-title>
                  </v-list-tile-content>
                </v-list-tile>
                <v-divider inset></v-divider>
                <v-list-tile>
                  <v-list-tile-action>
                    <v-icon color="primary">account_box</v-icon>
                  </v-list-tile-action>
                  <v-list-tile-content>
                    <v-list-tile-title>{{ agencyData.first_name }} {{ agencyData.last_name }}</v-list-tile-title>
                    <v-list-tile-sub-title>Contact person</v-list-tile-sub-title>
                  </v-list-tile-content>
                </v-list-tile>
                <v-divider inset></v-divider>
                <v-list-tile>
                  <v-list-tile-action>
                    <v-icon color="primary">mail</v-icon>
                  </v-list-tile-action>
                  <v-list-tile-content>
                    <v-list-tile-title>{{agencyData.email}}</v-list-tile-title>
                    <v-list-tile-sub-title>Email</v-list-tile-sub-title>
                  </v-list-tile-content>
                </v-list-tile>
                <v-divider inset></v-divider>
                <v-list-tile>
                  <v-list-tile-action>
                    <v-icon color="primary">location_on</v-icon>
                  </v-list-tile-action>
                  <v-list-tile-content>
                    <v-list-tile-title>{{agencyData.city}}</v-list-tile-title>
                    <v-list-tile-title>{{agencyData.address}}</v-list-tile-title>
                    <v-list-tile-sub-title>{{agencyData.country}} {{agencyData.zip_code}}</v-list-tile-sub-title>
                  </v-list-tile-content>
                </v-list-tile>
                <v-divider inset></v-divider>
                <v-list-tile>
                  <v-list-tile-action>
                    <v-icon color="primary">phone</v-icon>
                  </v-list-tile-action>
                  <v-list-tile-content>
                    <v-list-tile-title>{{agencyData.phone}}</v-list-tile-title>
                    <v-list-tile-sub-title>Phone</v-list-tile-sub-title>
                  </v-list-tile-content>
                </v-list-tile>
              <v-divider inset></v-divider>
                <v-list-tile>
                  <v-list-tile-action>
                    <v-icon color="primary">money</v-icon>
                  </v-list-tile-action>
                  <v-list-tile-content>
                    <v-list-tile-title>$ {{agencyData.balance}}</v-list-tile-title>
                    <v-list-tile-sub-title>Current Balance</v-list-tile-sub-title>
                    <v-btn
                    color="primary"
                    @click="adjustBalance"
                    dark
                    small
                    absolute
                    right
                    fab
                  >
                    <v-icon>add</v-icon>
                  </v-btn>
                  </v-list-tile-content>
                </v-list-tile>
              </v-list>
            </v-card-text>
          </v-card>
      </v-card>
    </v-flex>
    <div row>
      <v-alert
        :color="alert.type"
        icon="check_circle"
        :value="alert.status"
        transition="scale-transition"
      >
        {{ alert.message }}
      </v-alert>
    </div>
  </v-container>
</template>

<script>
import axios from "axios";
import Spinner from "vue-simple-spinner";
import defaultLogo from '../../../assets/placeholder_profile_photo-200x200.png'
export default {
  components: {
    Spinner
  },
  data() {
    return {
      alert: {
        status: false,
        message: "",
        type: ""
      },
      defaultLogo: defaultLogo,
      dataLoading: true,
      dialog: false,
      agencyData: [],
      agencyType: "Agency",
      agencies: [{id: ''}],
      selectedAgency: null,
      dialog: false,
      loading: true
    };
  },
  mounted: function() {
    this.getData();
  },
  methods: {
    alerting() {
      this.alert.status = !this.alert.status;
      setTimeout(() => {
        this.alert.status = !this.alert.status;
      }, 2500);
    },
    closeDialog() {
      this.dialog = !this.dialog;
    },
    adjustBalance() {
      this.$router.push("/admin/agencies/balance/" + this.$route.params.id);
    },
    goBack() {
      this.$router.go(-1);
    },
    editAgency(item) {
      this.$router.push({ path: `/admin/agencies/edit/${item.id}` });
    },
    getData() {
      this.dataLoading = true;
      axios.get("/users/" + this.$route.params.id).then(res => {
        this.agencyData = res.data.user;
        this.dataLoading = false;
      });
    },
    deleteItem(id) {
      axios.delete("/users/" + id).then(response => {
        this.$router.push("/admin/agencies");
      });
    }
  }
};
</script>

<style scoped>
.expansion-panel__header {
  background-color: #28AFAF !important;
}
.alert {
  position: absolute;
  bottom: 0;
  right: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/admin/Agencies/AgenciesSubShow.vue